import { Dialog } from '@ordr-as/umami-react/dialog';
import { PhoneInput } from '@ordr-as/umami-react/form';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { OrderLineDto } from '../../../../../../../generated-api/models/OrderLineDto';
import { useLocation } from '../../../../../../context/LocationContext';
import { useCartStore } from '../../../../../../context/cart/CartStore';

interface GiftCardPhoneNumberDialogProps {
  onClose: () => void;
  orderLine: OrderLineDto;
}

function GiftCardPhoneNumberDialog({ ...props }: GiftCardPhoneNumberDialogProps) {
  const { onClose, orderLine } = props;
  const { giftCardPhoneNumber, setGiftCardPhoneNumber } = useCartStore((x) => ({
    giftCardPhoneNumber: x.giftCardPhoneNumber,
    setGiftCardPhoneNumber: x.setGiftCardPhoneNumber,
  }));

  const intl = useIntl();
  const { formatCurrency } = useLocation();
  const [editPhoneNumber, setEditPhoneNumber] = useState<string | undefined>(undefined);

  const handlePhoneNumberInput = (phoneNumber: string) => {
    const phoneNumberWithoutSpaces = phoneNumber.replace(/\s/g, '');
    setEditPhoneNumber(phoneNumberWithoutSpaces);
  };

  const onSave = () => {
    if (editPhoneNumber) {
      setGiftCardPhoneNumber(editPhoneNumber);
      onClose();
    }
  };

  return (
    <Dialog
      className="w-full mx-4 tablet:w-1/2 tablet:mx-0"
      onClose={onClose}
      title={intl.formatMessage({ id: 'items.giftCard.dialog.phone.title' })}
      onAction={onSave}
      actionLabel={intl.formatMessage({ id: 'generic.save' })}
      isDisabledAction={!editPhoneNumber}
      alignTop
    >
      <div className="flex flex-col">
        <span className="text-base text-bold">{formatCurrency(orderLine.price)}</span>
        <span className="text-sm text-bold mb-3">{giftCardPhoneNumber}</span>
        <PhoneInput
          fullWidth
          required
          className="mb-[120px]"
          labelClassName="mb-2"
          label={intl.formatMessage({ id: 'items.giftCard.dialog.phone.title.input.label' })}
          description={intl.formatMessage({ id: 'items.giftCard.dialog.phone.input.description' })}
          sendPhoneNumberToParent={handlePhoneNumberInput}
          invalidHelpText={intl.formatMessage({ id: 'items.giftCard.dialog.phone.help.failure' })}
        />
      </div>
    </Dialog>
  );
}

export default GiftCardPhoneNumberDialog;
